export const LINE_HEIGHT = 28 // минимально - 25
export const ROW_TITLE_COLUMN_WIDTH = '6.8rem'
